// Generated by ReScript, PLEASE EDIT WITH CARE

import * as LumiSVG from "lumi-rescript/lib/es6/src/LumiSVG.res.js";
import * as LumiReact from "lumi-rescript/lib/es6/src/LumiReact.res.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Cone$LumiFacilityMap from "./Cone.res.js";
import * as Scale$LumiFacilityMap from "./Scale.res.js";
import * as Prelude$LumiFacilityMap from "./Prelude.res.js";
import * as MapLabel$LumiFacilityMap from "./MapLabel.res.js";
import * as ObjectStyle$LumiFacilityMap from "./ObjectStyle.res.js";

function CameraObject(props) {
  let __objectStyle = props.objectStyle;
  let objectTransform = props.objectTransform;
  let mapTransform = props.mapTransform;
  let objectStyle = __objectStyle !== undefined ? __objectStyle : ObjectStyle$LumiFacilityMap.empty;
  let scale = Scale$LumiFacilityMap.fixedInScreenSpace(props.scale, mapTransform, undefined, undefined);
  let className = ObjectStyle$LumiFacilityMap.className(objectStyle);
  return JsxRuntime.jsxs("g", {
    children: [
      JsxRuntime.jsx(Cone$LumiFacilityMap.make, {
        edgeLength: scale * 1.2,
        className: "cone"
      }),
      JsxRuntime.jsx(Cone$LumiFacilityMap.make, {
        edgeLength: scale * 0.36
      }),
      LumiReact.renderOption(undefined, objectStyle.label, label => {
        let labelPosition_0 = scale * 0.22;
        let labelPosition = [
          labelPosition_0,
          0
        ];
        let outerTransform = Transform$Linear.M23f.compose(mapTransform, objectTransform);
        return JsxRuntime.jsx(MapLabel$LumiFacilityMap.make, {
          outerTransform: outerTransform,
          position: labelPosition,
          className: "label is-unselectable",
          scale: scale,
          children: label
        });
      }),
      LumiReact.renderOption(undefined, objectStyle.title, title => JsxRuntime.jsx("title", {
        children: title
      }))
    ],
    className: className,
    onClick: props.onClick,
    transform: LumiSVG.Transform.Matrix.fromM23f_(objectTransform)
  });
}

let contents = Prelude$LumiFacilityMap.contents;

let Key = Prelude$LumiFacilityMap.Key;

let Document = Prelude$LumiFacilityMap.Document;

let DocInfo = Prelude$LumiFacilityMap.DocInfo;

let FacilityMap = Prelude$LumiFacilityMap.FacilityMap;

let $$Object = Prelude$LumiFacilityMap.$$Object;

let ObjectType = Prelude$LumiFacilityMap.ObjectType;

let Shape = Prelude$LumiFacilityMap.Shape;

let SvgIdMap = Prelude$LumiFacilityMap.SvgIdMap;

let LumiExt = Prelude$LumiFacilityMap.LumiExt;

let Camera = Prelude$LumiFacilityMap.Camera;

let Sensor = Prelude$LumiFacilityMap.Sensor;

let Indicator = Prelude$LumiFacilityMap.Indicator;

let Display = Prelude$LumiFacilityMap.Display;

let DisplayState = Prelude$LumiFacilityMap.DisplayState;

let make = CameraObject;

export {
  contents,
  Key,
  Document,
  DocInfo,
  FacilityMap,
  $$Object,
  ObjectType,
  Shape,
  SvgIdMap,
  LumiExt,
  Camera,
  Sensor,
  Indicator,
  Display,
  DisplayState,
  make,
}
/* LumiSVG Not a pure module */
